/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_UpdateInputs */



/**
* | output |
* | --- |
* | "Update failed." |
*
* @param {Auth_Error_UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_update = /** @type {((inputs?: Auth_Error_UpdateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_UpdateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise à jour échouée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualización fallida.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atualização falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamento fallito.")
	return /** @type {LocalizedString} */ ("Update failed.")
});